function DurationWatchedListener(player) {

	var listeners = [];
	
	var THIS = this;
	
	var durationWatched = 0;
	var durationIncrement = 3000; // In milliseconds. Lower values are more precise but more processor intensive.
	var interval = null;
	
	/**
	 * @returns {Number} seconds watched
	 */
	function getDurationWatched() {
		return durationWatched/1000;
	}
	
	function fireEvents() {
		for ( var int = 0; int < listeners.length; int++) {
			if (
				listeners[int]
				&& (listeners[int][0] >= (durationWatched - durationIncrement/2))
				&& (listeners[int][0] < (durationWatched + durationIncrement/2))
			) {
				var f = listeners[int][1];
				delete listeners[int];
				f(player,durationWatched/1000);
			}
		}
	}
	
	function incrementDuration() {
		durationWatched += durationIncrement;
		fireEvents();
	}
	
	function startIncrementing() {
		if (!interval && player) {
			interval = setInterval(incrementDuration,durationIncrement);
		}
	}

	function stopIncrementing() {
		if (interval) {
			clearInterval(interval);
			interval = null;
		}
	}

	/**
	 * Add a callback to fire at the specified number of seconds of video watched
	 * @param {Number} time in seconds
	 * @param {Function} callback
	 */
	function addListener(time,callback) {
		listeners.push([time*1000,callback]);
	}
	
	function removeListener(callback) {
		var newListeners = [];
		
		for ( var int = 0; int < listeners.length; int++) {
			if (listeners[int][1] !== callback) {
				newListeners.push(listeners[int]);
			}
		}
		
		listeners = newListeners;
	}
	
	player.onTime(function() {
		if (this.getState() == "PLAYING") {
			startIncrementing();
		} else {
			stopIncrementing();
		}
	});

	player.onPause(stopIncrementing);
	player.onError(stopIncrementing);
	player.onIdle(stopIncrementing);

	this.addListener = addListener;
	this.removeListener = removeListener;
	this.getDurationWatched = getDurationWatched;
};

module.exports = DurationWatchedListener;